import {ClientBrowsingHistory} from "../../domain/model/client_browsing_history";
import {Customer} from "../../domain/model/customer";
import {TJobCareerWithCustomerID} from "../../domain/repository/job_career_repository";
import {ClientBookmark} from "../../domain/model/client_bookmark";

interface IGetAllClientBrowsingHistoryByClientResponse {
    clientBrowsingHistories?: ClientBrowsingHistory[];
    customers?: Customer[];
    customerCount?: number;
    jobCareersWithCustomerID?: TJobCareerWithCustomerID[];
    clientBookmarks?: ClientBookmark[];
}

class GetAllClientBrowsingHistoryByClientResponse implements IGetAllClientBrowsingHistoryByClientResponse {
    public clientBrowsingHistories: ClientBrowsingHistory[];
    public customers: Customer[];
    public customerCount: number;
    public jobCareersWithCustomerID: TJobCareerWithCustomerID[];
    public clientBookmarks: ClientBookmark[];
}

export {
    GetAllClientBrowsingHistoryByClientResponse
}


// WEBPACK FOOTER //
// ./src/presentation/response/client_browsing_history_response.ts